import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import { CheckCircle, Error as ErrorIcon, OpenInNew } from '@mui/icons-material';
import { SocialPostResult } from '../../services/socialAPI';
import { getPlatformLabel } from '../../constants/platforms';

interface PublishResultsDialogProps {
  open: boolean;
  results: SocialPostResult[];
  onClose: () => void;
}

export const PublishResultsDialog: React.FC<PublishResultsDialogProps> = ({
  open,
  results,
  onClose,
}) => {
  const successCount = results.filter((r) => r.status === 'published').length;
  const failedCount = results.length - successCount;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Publish results</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {successCount} succeeded, {failedCount} failed
        </Typography>
        <List dense>
          {results.map((result) => {
            const ok = result.status === 'published';
            const label = getPlatformLabel(
              result.platform === 'twitter' ? 'twitter' : result.platform
            );
            return (
              <ListItem key={result.platform} alignItems="flex-start">
                <ListItemIcon sx={{ minWidth: 36 }}>
                  {ok ? (
                    <CheckCircle color="success" fontSize="small" />
                  ) : (
                    <ErrorIcon color="error" fontSize="small" />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={label}
                  secondary={
                    ok ? (
                      <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        Published
                        {result.platform_url && (
                          <Button
                            size="small"
                            href={result.platform_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            startIcon={<OpenInNew fontSize="inherit" />}
                            sx={{ ml: 1, minWidth: 0, p: 0 }}
                          >
                            View
                          </Button>
                        )}
                      </Box>
                    ) : (
                      result.error || 'Publish failed'
                    )
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PublishResultsDialog;
